import React from 'react';
import ENDPOINTS from '../../../../constants/endpoints';
import useDefaultRequest from '../../../../hooks/useDefaultRequest';
import ReportChartCard from '../../../../components/admin/reports/ReportChartCard';
import BrazilMapChart from '../../../../components/admin/reports/charts/BrazilMapChart';
import {moneyMask} from '../../../../utils/utils';

export default function DestinationsChart({dateFrom, dateTo}) {
    const {data, isLoading} = useDefaultRequest({
        url: ENDPOINTS.REPORTS_ECOMMERCE_DESTINATIONS,
        params: {date_from: dateFrom, date_to: dateTo},
        dataDefault: {},
    });
    const distribution = [...(data?.distribution || [])].sort((a, b) => b.revenue - a.revenue);

    return (
        <ReportChartCard title="Pedidos por Destino (Estado)" loading={isLoading} isEmpty={!distribution.length}>
            <BrazilMapChart
                data={distribution}
                dataKey="revenue"
                nameKey="state"
                valueFormatter={(v) => `R$ ${moneyMask(v)}`}
                tooltipFields={[
                    {key: 'revenue', label: 'Receita', formatter: (v) => `R$ ${moneyMask(v)}`},
                    {key: 'orders', label: 'Pedidos'},
                ]}
            />
        </ReportChartCard>
    );
}
